import React, { Component } from "react";
import FooterPage from "../partials/footerPage";


class Pieteikums extends Component {
  render() {

    //console.log(CarouselIndicators);
    return (
      <React.Fragment>
        <div>
        <div id = "singlePieteikums"
        className = "singlePage">
        <div className="container single-content-text">
              <iframe id="pieteikumsIframe" title="Pieteikums" className="resp-iframe" src="https://old.kanepes.lv/lv/pieteikums/" allowFullScreen style={{ height: "2700px", width: "100%", border: "none", overflow: "hidden" }}></iframe>    
        </div>
        </div>
          <FooterPage />
        </div>
      </React.Fragment>
    );
  }

}



export default (Pieteikums);
